import { useEffect, useState } from "react";
import { Col, Image, Row, Container } from "react-bootstrap";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { api, url } from "../axios/api";
import moment from 'moment';
import { Link } from "react-router-dom";
// Importando o logo do arquivo static (certifique-se de que a exportação está correta lá)
import { logo } from "../static";

const Index = () => {
    const [noticias, setNoticias] = useState([]);

    useEffect(() => {
        const fetchNoticias = async () => {
            try {
                const res = await api.get("/Noticia.php?action=listRecentsByLimit&limit=4");
                setNoticias(res.data.data || []);
            } catch (error) { 
                console.error("Erro ao carregar notícias:", error); 
            }
        };
        fetchNoticias();
    }, []);

    return (
        <>
            <Navbar />
            
            <main>
                {/* --- SEÇÃO HERO ELEGANTE MODIFICADA --- */}
                <div 
                    className="d-flex align-items-center position-relative overflow-hidden" 
                    style={{ 
                        minHeight: "85vh", 
                        // Cor de fundo castanha elegante sólida
                        backgroundColor: "#2c2219", 
                        color: "#f4f1ea" // Tom de branco envelhecido
                    }}
                >
                    {/* Camada de sobreposição para o padrão de logo repetido */}
                    <div 
                        className="position-absolute w-100 h-100"
                        style={{
                            top: 0,
                            left: 0,
                            // Usando a imagem do logo importada como background-image
                            backgroundImage: `url(${logo})`,
                            // Define o tamanho da miniatura (ex: 40px)
                            backgroundSize: '40px 40px',
                            // Faz a imagem repetir horizontalmente e verticalmente
                            backgroundRepeat: 'repeat',
                            // Define a opacidade para tornar o padrão sutil
                            opacity: 0.04, 
                            zIndex: 1 // Garante que fique atrás do conteúdo
                        }}
                    />

                    {/* Conteúdo do Hero (zIndex superior para ficar acima do padrão) */}
                    <Container className="position-relative" style={{ zIndex: 2 }}>
                        <Row>
                            <Col lg={8} className="py-5">
                                <h6 className="text-uppercase fw-bold mb-3" style={{ color: "#c5a47e", letterSpacing: "3px" }}>
                                    Paul Rodney & Associados
                                </h6>
                                <h1 className="display-3 fw-bold mb-4HeroTitulo" style={{ fontFamily: "'Playfair Display', serif" }}>
                                    Excelência Jurídica, Ética e Comprometimento com Resultados.
                                </h1>
                                <p className="lead fs-4 mb-5 opacity-90" style={{ maxWidth: "700px", fontWeight: "300" }}>
                                    Atuamos com rigor técnico e dedicação para garantir justiça e confiança aos nossos clientes. Nossa prática é pautada pela integridade e pela busca incansável pela melhor solução legal.
                                </p>
                                <div className="d-flex gap-3">
                                    <Link to="/contactos" className="btn btn-lg px-5 py-3 rounded-0 fw-bold" style={{ backgroundColor: "#c5a47e", color: "#fff", border: "none" }}>
                                        Agendar Consultoria
                                    </Link>
                                    <Link to="/sobre" className="btn btn-lg px-5 py-3 rounded-0 fw-bold btn-outline-light">
                                        Sobre o Escritório
                                    </Link>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>

                {/* --- SEÇÃO DE NOTÍCIAS / ARTIGOS JURÍDICOS --- */}
                <Container className="py-5 my-5">
                    <div className="d-flex align-items-end justify-content-between mb-5 border-bottom pb-3">
                        <div>
                            <h6 className="fw-bold text-uppercase mb-2" style={{ color: "#c5a47e" }}>Publicações</h6>
                            <h3 className="fw-bold mb-0" style={{ color: "#2c2219" }}>Atualizações e Notícias</h3>
                        </div>
                        <Link to="/noticias" className="text-decoration-none fw-bold" style={{ color: "#2c2219" }}>
                            Ver todas as publicações →
                        </Link>
                    </div>

                    <Row>
                        {noticias.length > 0 ? (
                            noticias.map((item, index) => (
                                <Col md={3} sm={6} key={item.id || index} className="mb-4">
                                    <Link to={`/noticias/detalhes/${item.id}/`} className="text-decoration-none">
                                        <div className="overflow-hidden mb-3 shadow-sm border" style={{ borderRadius: "2px" }}>
                                            <Image 
                                                src={url + "/uploads/" + item.foto} 
                                                className="w-100 object-fit-cover img-hover"
                                                style={{ height: "14em", transition: 'transform 0.6s ease' }}
                                            />
                                        </div>
                                        <small className="text-uppercase fw-bold opacity-60 mb-2 d-block" style={{ color: "#c5a47e", fontSize: "0.75rem" }}>
                                            {moment(item.createdAt).format("DD [de] MMMM, YYYY")}
                                        </small>
                                        <h6 className="fw-bold line-clamp-2" style={{ color: "#2c2219", minHeight: '2.8em', fontSize: "1.1rem" }}>
                                            {item.titulo}
                                        </h6>
                                    </Link>
                                </Col>
                            ))
                        ) : (
                            <Col className="text-center py-5 text-muted">Carregando atualizações...</Col>
                        )}
                    </Row>
                </Container>
            </main>

            <Footer />

            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700&family=Inter:wght@300;400;600&display=swap');
                
                body { font-family: 'Inter', sans-serif; }
                .img-hover:hover { transform: scale(1.08); }
                .line-clamp-2 {
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;  
                    overflow: hidden;
                }
                .btn-outline-light:hover {
                    background-color: #fff;
                    color: #2c2219 !important;
                }
                /* Ajuste responsivo para o título no mobile se necessário */
                @media (max-width: 768px) {
                    .display-3.HeroTitulo { font-size: 2.5rem; }
                }
            `}</style>
        </>
    );
};

export default Index;